import { deviceInfoApi } from "../../../api/api";

const actions = {
    async deviceUidAction(context, params) {
        try {
            context.commit('deviceUidMutation', params);
        } catch (error) {
            console.log(error);
        }
    },
    async openStatusAction(context, params) {
        try {
            const result = await deviceInfoApi(params);

            return new Promise((resolve, reject) => {
                if (result.status === 200) {
                    context.commit('openStatusMutation', result.data.opened);
                    resolve(result.data);
                }
                else reject(result.status);
            });
        } catch (error) {
            console.log(error);
        }
    },
    async updateOpenStatusAction(context, params) {
        context.commit('openStatusMutation', params);
    },
};

export default actions;
